import Image from 'next/image';
import styled, { css } from 'styled-components';

import { mixin } from '@wconcept/wconcept-ui-renewal/styles/index';

interface IProps {
  width?: number;
  height?: number;
  $pb?: number;
  $fitType?: 'cover' | 'contain' | 'adapt';
}

export const Box = styled.span<IProps>`
  position: relative;
  overflow: hidden;
  display: block;
  width: 100%;

  ${props => css`
    width: ${typeof props.width === 'number'
      ? `${props.width}px`
      : props.width};
    height: ${typeof props.height === 'number'
      ? `${props.height}px`
      : props.height};

    @media ${({ theme }) => theme.media.smMax} {
      width: ${typeof props.width === 'number'
        ? `${mixin.pxToVw(String(props.width))}`
        : props.width};
      height: ${typeof props.height === 'number'
        ? `${mixin.pxToVw(String(props.height))}`
        : props.height};
    }
  `}

  ${props => {
    if (props.$pb) {
      return css`
        padding-bottom: ${props.$pb}%;
      `;
    }
    return null;
  }}
`;

const getImgStyle = () => css`
  width: 100% !important;
  height: 100% !important;
  /* object-fit: cover !important; */
  z-index: 0;
`;

export const LazyImg = styled(Image)<IProps>`
  ${getImgStyle}
  object-fit: ${({ $fitType = 'cover' }) => $fitType} !important;
`;
